import React from 'react'
import { Box, Typography } from '@mui/material'
import { TooltipSeeker } from '@ui-seeker/core'

import { isMainRow } from 'Pages/AnalyzersV2/@components/Table/@utils'
import { dataColors, dsColorNew } from '@palette'


export default function avgGapColumn(mainName) {
	return {
		name: '__avgGap',
		label: 'Avg gap',
		render: (_, row) => <AvgGapCell row={row} mainName={mainName}/>,
	}
}

function AvgGapCell({ row, mainName }) {
	// Same name the website column prints: `name` still holds the raw alias.
	const rowName = row?.nameFilter || row?.name

	// The main row has no gap against itself, so it carries its average price —
	// the baseline every other row in this column is measured against.
	if (isMainRow(row)) {
		const avgPrice = row?.avgPrice

		return <TooltipSeeker title={avgPrice == null ? '' : `${rowName} average price across the period`}>
			<Box sx={{ textAlign: 'center', width: 90 }}>
				<Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: dsColorNew.appBlueHover }}>
					{avgPrice == null ? 'N/A' : avgPrice.toFixed(2)}
				</Typography>
			</Box>
		</TooltipSeeker>
	}

	const avgGap = row?.avgGap

	if (avgGap == null) {
		return <Box sx={{ textAlign: 'center', width: 90 }}>
			<Typography variant="caption" sx={{ color: dsColorNew.textSubtle }}>N/A</Typography>
		</Box>
	}

	const isCheaper = avgGap >= 0
	const tooltip = `${mainName || 'Main'} is on average ${Math.abs(avgGap).toFixed(1)}% ${isCheaper ? 'cheaper' : 'more expensive'} than ${rowName}`

	return <TooltipSeeker title={tooltip}>
		<Box sx={{ textAlign: 'center', width: 90 }}>
			{/* The only colour of the gaps: the conclusion for the row, as a soft tint */}
			<Box component="span" sx={{
				display: 'inline-block', px: .75, py: .25, borderRadius: '6px', fontSize: 12.5, fontWeight: 700,
				color: isCheaper ? dsColorNew.successText : dataColors.red700,
				backgroundColor: isCheaper ? dsColorNew.successBg : dsColorNew.dangerBg,
			}}>
				{isCheaper ? '+' : '−'}{Math.abs(avgGap).toFixed(1)}%
			</Box>
		</Box>
	</TooltipSeeker>
}
